import { useEffect } from 'react'

export const usePageScrollLock = (shouldLock: boolean) => {
  useEffect(() => {
    const body = document.body
    const html = document.documentElement
    const root = document.getElementById('root')
    const layout = document.getElementById('app-layout-main')

    const prevBodyOverflow = body.style.overflow
    const prevHtmlOverflow = html.style.overflow
    const prevRootOverflow = root?.style.overflow

    if (shouldLock) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      body.style.overflow = 'hidden'
      html.style.overflow = 'hidden'
      if (root) root.style.overflow = 'hidden'
    } else {
      body.style.overflow = 'auto'
      html.style.overflow = 'auto'
      // IDK why but with next line scrollTo top doesn't work
      // if (root) root.style.overflow = 'auto'
    }

    if (layout) {
      layout.style.overflow = 'auto'
    }

    return () => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
      body.style.overflow = prevBodyOverflow || 'auto'
      html.style.overflow = prevHtmlOverflow || 'auto'
      if (root) root.style.overflow = prevRootOverflow ?? 'auto'
    }
  }, [shouldLock])
}
